import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';


export type ShellVariant = 'card' | 'classic';

const STORAGE_KEY = 'wn.shell';

const isVariant = (value: string | null | undefined): value is ShellVariant =>
  value === 'card' || value === 'classic';

export const readShellVariant = (search?: string): ShellVariant => {
  if (typeof window === 'undefined') return 'card';

  const fromUrl = new URLSearchParams(search ?? window.location.search).get('shell');
  if (isVariant(fromUrl)) {
    try {
      window.localStorage.setItem(STORAGE_KEY, fromUrl);
    } catch {
    }
    return fromUrl;
  }

  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (isVariant(stored)) return stored;
  } catch {
  }

  const fromEnv = String(import.meta.env.VITE_CARD_SHELL ?? '').toLowerCase();
  return fromEnv === '0' || fromEnv === 'false' ? 'classic' : 'card';
};

export const isCardShellEnabled = (search?: string): boolean =>
  readShellVariant(search) === 'card';

export const useIsCardShell = (): boolean => {
  const { search } = useLocation();
  return useMemo(() => isCardShellEnabled(search), [search]);
};
